import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
import logFactory from '../../utils/logger';
var log = logFactory('splitio-engine:matcher');
import thenable from '../../utils/promise/thenable';
function checkTreatment(evaluation, acceptableTreatments, parentName) {
  var _context, _context2, _context3, _context4, _context5;
  var matches = false;
  if (_Array$isArray(acceptableTreatments)) {
    matches = _indexOfInstanceProperty(acceptableTreatments).call(acceptableTreatments, evaluation.treatment) !== -1;
  }
  log.debug(_concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "[dependencyMatcher] Parent split \"".concat(parentName, "\" evaluated to \"")).call(_context5, evaluation.treatment, "\" with label \"")).call(_context4, evaluation.label, "\". ")).call(_context3, parentName, " evaluated treatment is part of [")).call(_context2, acceptableTreatments, "] ? ")).call(_context, matches, "."));
  return matches;
}
function dependencyMatcherContext(_ref, storage) {
  var split = _ref.split,
    treatments = _ref.treatments;
  return function dependencyMatcher(_ref2, splitEvaluator) {
    var _context6, _context7;
    var key = _ref2.key,
      attributes = _ref2.attributes;
    log.debug(_concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = "[dependencyMatcher] will evaluate parent split: \"".concat(split, "\" with key: ")).call(_context7, _JSON$stringify(key), " ")).call(_context6, attributes ? "\n attributes: ".concat(_JSON$stringify(attributes)) : ''));
    var evaluation = splitEvaluator(key, split, attributes, storage);
    if (thenable(evaluation)) {
      return evaluation.then(function (ev) {
        return checkTreatment(ev, treatments, split);
      });
    } else {
      return checkTreatment(evaluation, treatments, split);
    }
  };
}
export default dependencyMatcherContext;